import React from "react";
import styled from "styled-components";
import {ISquad} from "apps/DRAW_PREDICTOR/modules/reducers";
import {ReactComponent as EmptyPredictionIcon} from "apps/DRAW_PREDICTOR/assets/images/icons/emptyPrediction.svg";
import {media} from "assets/css/media";
import {FLAGS_URL} from "apps/DRAW_PREDICTOR/modules/constants";

const EmptyFlagStyled = styled(EmptyPredictionIcon)`
	margin: 0 15px;

	@media (max-width: ${media.mobile}) {
		margin: 0;
		margin-bottom: 8px;
	}
`;

const Flag = styled.div`
	width: 52px;
	height: 35px;
	margin: 0 15px;
	img {
		width: auto;
		max-width: 100%;
	}

	@media (max-width: ${media.mobile}) {
		margin: 0;
		margin-bottom: 8px;
	}
`;

interface IProps {
	selectedSquad: ISquad | null;
	isEditing?: boolean;
}

export const SquadFlag: React.FC<IProps> = ({selectedSquad, isEditing = false}) => {
	const imageUrl = `${FLAGS_URL}${selectedSquad?.shortName || ""}.png`;
	return selectedSquad && !isEditing ? (
		<Flag>
			<img src={imageUrl} alt={selectedSquad.name} />
		</Flag>
	) : (
		<EmptyFlagStyled />
	);
};
